import { GridCellProps } from '@progress/kendo-react-grid';
import { useContext } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import PopUp from 'src/components/design-system/PopUp';
import { EditCellContext } from 'src/contexts/EditCellContext';
import { getIcon } from 'src/utils/icons';

const AdjustBalanceErrorCell = (props: GridCellProps) => {
  const [cellClick] = useContext(EditCellContext);
  const { updateErrorMessages } = cellClick?.('');
  return (
    <GridCellBase {...props} className={`overflow-visible-imp`} disableToolTip>
      <PopUp
        popupAlign={{ horizontal: 'left', vertical: 'bottom' }}
        anchorAlign={{ horizontal: 'right', vertical: 'center' }}
        className="max-h-[180px] "
        content={
          <div className="m-1 max-w-[350px]">
            <PopUpContentWrapper type="Error" contents={updateErrorMessages} />
          </div>
        }
      >
        <div className="flex justify-center items-center">{getIcon(updateErrorMessages)}</div>
      </PopUp>
    </GridCellBase>
  );
};

export default AdjustBalanceErrorCell;
